// removed by extract-text-webpack-plugin
module.exports = {"column":"c-OrderSummary__column","note":"c-OrderSummary__note","header":"c-OrderSummary__header","show":"c-OrderSummary__show"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/OrderSummary/OrderSummary.scss
// module id = 894
// module chunks = 0